export const MESSAGES_LIMIT = 100;
export const INITIAL_MESSAGE_INDEX = 0;
export const INFINITY_TIME = -1;
